/**
 * @generated SignedSource<<96c75c93abf73a1afb4fa793b5533096>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CompetitionScoringCriteriaPageQuery$variables = {
  slug: string;
};
export type CompetitionScoringCriteriaPageQuery$data = {
  readonly competitionBySlug: {
    readonly id: string;
    readonly scoringCriteria: ReadonlyArray<{
      readonly description: string | null | undefined;
      readonly id: string;
      readonly title: string;
      readonly weight: number;
    }>;
    readonly slug: string;
    readonly viewerCanEdit: boolean;
  } | null | undefined;
};
export type CompetitionScoringCriteriaPageQuery = {
  response: CompetitionScoringCriteriaPageQuery$data;
  variables: CompetitionScoringCriteriaPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "slug"
      }
    ],
    "concreteType": "Competition",
    "kind": "LinkedField",
    "name": "competitionBySlug",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": "viewerCanEdit",
        "args": [
          {
            "kind": "Literal",
            "name": "action",
            "value": "UPDATE_COMPETITION"
          }
        ],
        "kind": "ScalarField",
        "name": "viewerCan",
        "storageKey": "viewerCan(action:\"UPDATE_COMPETITION\")"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CompetitionScoringCriterion",
        "kind": "LinkedField",
        "name": "scoringCriteria",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "weight",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionScoringCriteriaPageQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompetitionScoringCriteriaPageQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "d0ef4461c6c8995c5af9937ae0710faa",
    "id": null,
    "metadata": {},
    "name": "CompetitionScoringCriteriaPageQuery",
    "operationKind": "query",
    "text": "query CompetitionScoringCriteriaPageQuery(\n  $slug: String!\n) {\n  competitionBySlug(slug: $slug) {\n    id\n    slug\n    viewerCanEdit: viewerCan(action: UPDATE_COMPETITION)\n    scoringCriteria {\n      id\n      title\n      description\n      weight\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d8d94c1436feb6acf6c9708d0835a2cc";

export default node;
